export const warehouseZh = {
  // 页面标题
  title: '仓库',
  storageLocations: '仓位',
  
  // 仓库字段
  code: '仓库编码',
  name: '仓库名称',
  nameEn: '英文名称',
  nameCn: '中文名称',
  description: '描述',
  address: '地址',
  contactPerson: '联系人',
  contactPhone: '联系电话',
  isDefault: '默认仓库',
  sortOrder: '排序',
  
  // 仓位字段
  locationCode: '仓位编码',
  locationName: '仓位名称',
  zone: '区域',
  aisle: '通道',
  rack: '货架',
  level: '层',
  position: '位置',
  capacity: '容量',
  
  // 状态
  status: '状态',
  statusActive: '启用',
  statusInactive: '停用',
  statusMaintenance: '维护中',
  statusFull: '已满',
  statusReserved: '已预留',
  
  // 操作
  createWarehouse: '新建仓库',
  editWarehouse: '编辑仓库',
  deleteWarehouse: '删除仓库',
  createLocation: '新建仓位',
  editLocation: '编辑仓位',
  deleteLocation: '删除仓位',
  viewLocations: '查看仓位',
  
  // 统计
  warehouseCount: '仓库数量',
  locationCount: '仓位数量',
  partsCount: '零件数量',
  
  // 提示
  deleteWarehouseConfirm: '确定要删除该仓库吗？删除后将无法恢复。',
  deleteLocationConfirm: '确定要删除该仓位吗？删除后将无法恢复。',
  warehouseHasLocations: '该仓库下还有仓位，请先删除仓位。',
  locationHasParts: '该仓位下还有零件，请先移除零件。',
  
  // 成功/失败消息
  createSuccess: '创建成功',
  updateSuccess: '更新成功',
  deleteSuccess: '删除成功',
  createFailed: '创建失败',
  updateFailed: '更新失败',
  deleteFailed: '删除失败',
  
  // 表单
  selectWarehouse: '选择仓库',
  selectLocation: '选择仓位',
  allWarehouses: '全部仓库',
  allLocations: '全部仓位',
  noWarehouse: '暂无仓库',
  noLocation: '暂无仓位',
  
  // 搜索
  searchPlaceholder: '搜索仓库编码或名称',
  searchLocationPlaceholder: '搜索仓位编码或名称',
  
  // 批量导入
  bulkImport: '批量导入',
  downloadTemplate: '下载模板',
  importFile: '导入文件',
  importSuccess: '导入成功',
  importFailed: '导入失败',
  importResult: '导入结果',
  successCount: '成功',
  failedCount: '失败',
  importErrors: '错误详情',
  row: '行',
  dragOrClick: '拖拽文件到此处或点击上传',
  supportFormat: '支持 CSV、Excel 格式',
  importing: '正在导入...',
  parseError: '文件解析失败',
};

export type WarehouseTranslations = typeof warehouseZh;

